import { HttpContextToken } from "@angular/common/http";

/** When true, RestHttpErrorsInterceptor will not show a global error toast. */
export const SKIP_ERROR_ALERT = new HttpContextToken<boolean>(() => false);
